"use strict";

angular.module("admin")

	.controller("AdminClientsCtrlParent", ["$scope", "Utils", "$uibModal", "AdminClientsService", "toastr", "$location", function ($scope, Utils, $uibModal, AdminClientsService, toastr, $location) {

		var deleteModal, confirmNightModal;


		/**
		 * Relancer le script de nuit
		 */
		$scope.startScriptScheduled = function () {
			AdminClientsService.startScriptScheduled()
				.then(()=> {
					toastr.success("", "Script de nuit terminé");
					confirmNightModal.close();
				}).catch((response) => {
					let errorMessage = "Problème lors du script de nuit.";
					if (response.data !== undefined && response.data.message) {
						errorMessage += response.data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.startScriptDay = function () {
			AdminClientsService.startScriptDay()
				.then(() => {
					toastr.success("", "Script de jour terminé");
					confirmNightModal.close();
				}).catch((response) => {
					const data = response.data;
					var errorMessage = "Problème lors du script de jour.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.startScriptFix = function () {
			AdminClientsService.startScriptFix()
				.then(() => {
					toastr.success("", "Script de fix terminé");
					confirmNightModal.close();
				}).catch((response) => {
					const data = response.data;
					var errorMessage = "Problème lors du script de fix.";
					if (data !== undefined && data.message) {
						errorMessage += data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};


		/**
		 * Ouvrir la modal de suppression d'un client.
		 */
		$scope.openDeleteModal = function (client) {
			$scope.data.clientToDelete = client;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
		 * Ouvrir la modal de confirmNightModal
		 */
		$scope.openNightModal = function () {
			confirmNightModal = Utils.openModal($uibModal, "confirmNightModal.html", $scope);
		};

		/**
		 * Ouvrir la modal de confirmNightModal
		 */
		$scope.openFixModal = function () {
			confirmNightModal = Utils.openModal($uibModal, "confirmFixModal.html", $scope);
		};

		/**
		 * Ouvrir la modal de confirmNightModal
		 */
		$scope.openDayModal = function () {
			confirmNightModal = Utils.openModal($uibModal, "confirmDayModal.html", $scope);
		};


		/**
		 * Supprimer un client, notifications, et fermer la modale en cas de succès.
		 * @param client le client à supprimer
		 */
		$scope.deleteClient = function (client) {

			AdminClientsService.deleteClient(client)
				.then(() => {
					AdminClientsService.refreshUserClients((clients) => {
						$scope.data.clients = clients.filter(c => c.name.toLowerCase() !== "technique");
						toastr.success("L'organisation " + client.name + " a bien été supprimée.", "Organisation supprimée");
						$location.path("/admin/filiales");						
					});

				})
				.catch(data => {
					let errorMessage = "Problème lors de la suppression de l'organisation.";
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
			deleteModal.close();
		};


		$scope.isCurrentReferential = function(schema) {
			return schema && schema === AdminClientsService.getCurrentReferential();
		};


	}]);
